import $ from 'jquery'
import houseRescoure1 from '@/components/houseRescoure1'  //  新建房源
import houseUser from '@/components/houseUser'  //  新建房源
import {houseFeaturesDict} from '@/filters/modules/house' // 房间特色枚举
export default {

  components: {
    houseRescoure1, houseUser
  },

  beforeCreate: function () {
    // console.log('mounted是否会触发')
    // var uesrApi = this.$store.state.accountUrl + 'user/list' // 房东
    let treeArea = this.$store.state.accountUrl + 'unit/tree/f/area'
    let houseApi = this.$store.state.houseUrl + 'list/houseSpaceManager'
    // 搜索小区
    this.$options.methods.unitSelect(this, treeArea)    // 查询片区
    // 搜索房东
    // this.$options.methods.landlordSearch(this, uesrApi, '')
    // 搜索预录入房源
    let req = {}
    req.keywordAddressManager = ''
    req.originalRentType = null
    this.$options.methods.houseListSearch(this, houseApi, req)   // 查询房源信息
  },
  data: function () {
    var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
    var size = (rule, value, callback) => {
      if (!reg.test(value) || value <= 0) {
        callback(new Error('请填写正确的面积'))
      } else {
        callback()
      }
    }
    return {
      houseFeaturesDict,
      landlord: '房东',
      renter: '租客',
      disable: Boolean(this.disabled),
      disabledFalse: true,
      options: [],
      userNameOptions: [],
      activeName2: '1',
      tableNumber: '1',
      chooseHouseTypeShow: false,
      houseRepeat: 0, // 判断集中式房型有无重复
      addBean: { // 新增托管数据
        getPrice: '', // 价格
        getPrice1: '', // 价格
        companyId: '', // 所属公司Id
        houseSpaceDescribe: '', // 描述
        zone: '城东片区', // 片区
        zoneId: '', // 片区
        zoneData: [],
        userId: '', // 房东ID
        landlordName: '',
        landlordPhone: '', // 手机号
        propertyType: 'D',
        originalRentType: '',
        houseSpaceManagerId: '',
        roomNumber: '0',
        bedroom_number: 6,
        reqBaseSaveHouseSpaceBeanList: [
          {
            bedroomType: 'MASTER',
            direction: '',
            houseSpaceArea: '',
            houseSpaceArea1: '',
            rentalPrice: '',
            roomNum: '',
            rentalPrice1: '',
            roomName: 'A',
            houseSpaceFeatureList: []
          }
        ]
      },
      addBean1: { // 新增托管数据
        houseSpaceManagerArea: '', // 面积
        bedroomNumber: '1', // 卧室数量
        blockName: '', // 小区
        buildingNo: '', // 栋
        businessId: '', // 业务ID
        currentFloor1: 0, // 当前楼层
        floorHeight: 0, // 总楼高
        getPrice: '', // 价格
        getPrice1: '', // 价格
        houseSpaceDescribe: '', // 描述
        houseSpaceFeatureList: [], // 优势
        kitchenNumber: '0', // 厨房数量
        livingRoomNumber: '1', // 客厅数量
        landlordPhone: '', // 手机号
        roomNo: '', // 室号
        toiletNumber: '1', // 卫生间数量
        direction: '', // 朝向
        zone: '城东片区', // 片区
        zoneId: '', // 片区
        unitNo: '', // 单元号
        userId: '', // 房东ID
        landlordCertType: 'ID', // 身份证件类型
        landlordCertNumber: '', // 证件号码
        landlordName: '',
        sex: 'M'
      },
      centralizeData: { // 新增集中式房源
        userId: '', // 房东ID
        landlordCertType: 'ID', // 身份证件类型
        landlordCertNumber: '', // 证件号码
        landlordName: '',
        sex: 'M',
        companyId: '',
        zone: '城东片区', // 片区
        blockName: '', // 小区
        houseSpaceFeatureList: [], // 优势
        housePrice: '', // 价格
        housePrice1: '', // 价格
        floor: 10, // 楼层
        currentFloor1: [], // 选择楼层
        roomNumber: '', // 每层房间数量
        memo: '', // 备注
        unitNo: '',
        buildingNo: '',
        zoneId: '',
        houseOwnershipCertificateNumber: '',
        insuranceStatus: 'YES',
        city: '',
        province: '',
        district: '',
        blockId: '',
        reqCommonCentralizeHouseSpaceBeanList: [ // 户型
          {
            name: '',
            bedroomNumber: '1',
            livingRoomNumber: '1',
            kitchenNumber: '0',
            toiletNumber: '1',
            direction: '',
            houseSpaceManagerArea: '',
            houseSpaceFeatureList: [],
            roomNoList: [],
            roomList: []
          }
        ]
      },
      centralizeData1: { // 新增集中式房源
        userId: '', // 房东ID
        landlordCertType: 'ID', // 身份证件类型
        landlordCertNumber: '', // 证件号码
        landlordName: '',
        sex: 'M',
        zone: '城东片区', // 片区
        blockName: '', // 小区
        houseSpaceFeatureList: [], // 优势
        housePrice: '', // 价格
        housePrice1: '', // 价格
        floor: 10, // 楼层
        currentFloor1: [], // 选择楼层
        roomNumber: '', // 每层房间数量
        memo: '', // 备注
        unitNo: '',
        buildingNo: '',
        houseOwnershipCertificateNumber: '',
        insuranceStatus: 'YES',
        city: '',
        province: '',
        district: '',
        blockId: '',
        reqCommonCentralizeHouseSpaceBeanList: [ // 户型
          {
            name: '',
            bedroomNumber: '1',
            livingRoomNumber: '1',
            kitchenNumber: '0',
            toiletNumber: '1',
            direction: '',
            houseSpaceManagerArea: '',
            roomNoList: []
          }
        ]
      },
      reqCommonCentralizeHouseSpaceBeanList1: { // 集中式备份信息
        name: '',
        bedroomNumber: '1',
        livingRoomNumber: '1',
        kitchenNumber: '0',
        toiletNumber: '1',
        direction: 'EAST',
        houseSpaceManagerArea: '',
        roomNoList: []
      },
      reqCommonCentralizeHouseSpaceBeanList: { // 集中式备份信息
        name: '',
        bedroomNumber: '1',
        livingRoomNumber: '1',
        kitchenNumber: '0',
        toiletNumber: '1',
        direction: '',
        houseSpaceManagerArea: '',
        roomNoList: []
      },
      houseSpaceIndex: '',
      houseSpaceList: [], // 集中式房间列表
      houseSpaceListChoose: [], // 当前选中的房间列表
      houseSpaceListing: [], // 集中式房间已被选中的房间列
      rules2: {
        landlordName: [{required: true, message: '请输入房东姓名', trigger: 'blur'}],
        landlordCertNumber: [{required: true, min: 15, max: 18, message: '请输入房东证件号码', trigger: 'blur'}],
        landlordPhone: [{message: '请输入正确的房东联系方式', trigger: 'blur'}],
        blockName: [{message: '请输入小区', trigger: 'blur'}],
        zone: [{message: '请选择片区', trigger: 'blur'}],
        houseSpaceManagerArea1: [{message: '请输入房间面积', trigger: 'blur'},
          {validator: size, message: '请填写正确的面积', trigger: 'blur'}],
        room: [{message: '请输入正确房型', trigger: 'blur'}],
        roomNo: [{message: '请输入房间号', trigger: 'blur'}]
      },
      rules3: {
        landlordName: [{required: true, message: '请输入房东姓名', trigger: 'blur'}],
        landlordCertNumber: [{required: true, min: 15, max: 18, message: '请输入房东证件号码', trigger: 'blur'}],
        landlordPhone: [{message: '请输入正确的房东联系方式', trigger: 'blur'}],
        blockName: [{required: true, message: '请输入小区', trigger: 'blur'}],
        zone: [{required: true, message: '请选择片区', trigger: 'blur'}],
        // houseSpaceManagerArea1: [{message: '请输入房间面积', trigger: 'blur'},
          // {validator: size, required: true, message: '请填写正确的面积', trigger: 'blur'}],
        room: [{message: '请输入正确房型', trigger: 'blur'}],
        roomNo: [{message: '请输入房间号', trigger: 'blur'}],
        // companyId: [{required: true, message: '请选择所属公司', trigger: 'change'}]
        // direction: [{message: '请选择朝向', trigger: 'blur'}]
      },
      rules4: {
        landlordName: [{required: true, message: '请输入房东姓名', trigger: 'blur'}],
        landlordCertNumber: [{required: true, min: 15, max: 18, message: '请输入房东证件号码', trigger: 'blur'}],
        landlordPhone: [{message: '请输入正确的房东联系方式', trigger: 'blur'}],
        // blockName: [{required: true, message: '请输入小区', trigger: 'blur'}],
        houseSpaceManagerId: [{required: true, message: '请选择房源地址', trigger: 'change'}],
        companyId: [{ required: true, message: '请选择所属公司', trigger: 'change' }],
        // 房源间数 放在其他位置校验
        // roomNumber: [{required: true, message: '请输入房源间数', trigger: 'change'}],
        // reqBaseSaveHouseSpaceBeanList: [{type: 'array', required: true, message: '请至少选择一个活动性质', trigger: 'change'}],
        // houseSpaceArea1: [{required: true}],
        // rentalPrice1: [{required: true, message: '请输入出租价格', trigger: 'blur'}],
        // houseSpaceFeatureList: [{type: 'array', required: true, message: '请至少选择一项房间配置', trigger: 'change'}],
      },
      restaurants: [
        { 'value': '德信晓宸', 'id': '' },
        { 'value': '八方城', 'id': '' },
        { 'value': '德信东望', 'id': '' }
      ],
      companyListAll: [],
      houseRestaurants: [], // 预录入列表
      restaurants1: [], // 预录入列表
      landlordList: [], // 房东列表
      options2: [ // 片区列表
        {
          label: '江苏',
          cities: [
            {
              label: '南京'
            },
            {
              label: '苏州'
            }
          ]
        }, {
          label: '浙江',
          cities: [
            {label: 'hangz', value: ''},
            {label: 'hangz', value: ''}
          ]
        }
      ],
      options4: [],
      loading: true,
      props: {
        value: 'label',
        children: 'cities'
      },
      unit: [], // 片区列表
      readonly: true,
      mix1: {
        treeArea: this.$store.state.accountUrl + 'unit/tree/f/area', // 查询片区
        houseApi: this.$store.state.houseUrl + 'list/houseSpaceManager' // 查询预录入房源列表
      },
      address: {
        pLists: [],
        cLosts: [],
        dLists: []
      },
      clickOver: true,
      chooseHouseListShow: false,
      addShow: false,
      removeHouseList: [],
      unitList: [], // 片区列表
      bankSearch: this.$store.state.searchUrl + 'baseDataInfo', // 查询银行

      optionsNext: {
        projectId: null
      },
      // addCompanySwitch: false   // 新增关联公司开关
    }
  },
  props: ['mix', 'formLabelWidth', 'disabled'],
  mounted () {
    $('.el-dialog--small,.el-dialog--tiny').width(650)
    // 在mounted 中触发集中式房源的请求。
    this.fetchProject()
    this.companyListFind()
  },
  methods: {
    selectProject (id) {
      let project = this.optionsNext.projectId.find(item => item.houseSpaceManagerId === id)

      this.centralizeData.blockId = project.blockId
      this.centralizeData.blockName = project.blockName
      this.centralizeData.zoneId = project.zoneId
      this.centralizeData.zone = project.zone
    },

    fetchProject(str) {
      // 集中式房源数据请求
      const url = this.urljoin(this.urlList.house, 'list/houseSpaceManager')
      let params = {
        houseSpaceManagerType: 'C_PARENT_HOUSE',
        keywordAddressManager: str,
        pageNo: 1,
        pageSize: 50,
      }
      this.$http.post(url, params).then(res => {
        if (res.data.code === 200) {
          this.optionsNext.projectId = res.data.data.list.map(item => (
            {
              ...item,
              label: item.blockName,
              value: item.houseSpaceManagerId
            }
          ))
        }
      })
    },

    landlordSearch (_this, userUrl, name) { // 搜索房东信息
      let dataList = {}
      dataList.pageNo = 1
      dataList.pageSize = 50
      // dataList.userType = 'P'
      dataList.username = name
      _this.$http.post(userUrl, dataList).then(({data}) => {
        var data1 = data.data.list
        var op = {}
        var option = []
        for (var i = 0; i < data1.length; i++) {
          if (data1[i].username === '' || data1[i].username === null || typeof (data1[i].username) === 'undefined') {
          } else {
            op = {}
            op.id = data1[i].id
            op.phone = data1[i].phone
            op.sex = data1[i].sex
            op.value = data1[i].username
            option.push(op)
          }
        }
        _this.landlordList = option
      })
      // }
    },
    closeForm () {
      this.$emit('listenToParentEvent', false)
      this.$options.methods.gbAddBean(this)
      this.$options.methods.gbAddBean1(this)
      this.tableNumber = '1'
      this.activeName2 = '1'
    },
    directionChange (data) { // 解析房源朝向
      switch (data) {
        case 'WIFI':
          data = 'WIFI'
          break
        case '停车位':
          data = 'PARK'
          break
        case '朝南':
          data = 'FACE_SOUTH'
          break
        case '独卫':
          data = 'PRIVATE_TOILET'
          break
        case '双阳台':
          data = 'DUAL_BALCONY'
          break
        case '空凋':
          data = 'AIR_CONDITIONER'
          break
        case '私人阳台':
          data = ' PRIVATE_BALCONY'
          break
      }
      return data
    },
    tableClick (data) { // 切换集中式以及分散式
      if (this.clickOver) {
        this.tableNumber = data.name
        this.$options.methods.gbAddBean(this)
        this.$options.methods.gbAddBean1(this)
      }
    },
    // 分散式新增
    depositAdd (addBean) {
      this.$refs[addBean].validate((valid) => {
      if (valid) {
        console.log(valid)        // valid === true
          // 新增开始
      if (this.clickOver) {
        this.clickOver = false
        var data = JSON.parse(JSON.stringify(this.addBean))
         // 整租的时候需要验证房源
        let roomModel = data.reqBaseSaveHouseSpaceBeanList[0]
        let roomNum = roomModel.roomNum
         if (
          data.originalRentType === 'ENTIRE_RENT' && (roomNum === '' || isNaN(roomNum))
        ) {
          this.$message({
            message: '请填写房源间数',
            type: 'error'
          })
          this.clickOver = true
          return

        }
        data = {
          ...data,
          reqBaseSaveHouseSpaceBeanList: data.reqBaseSaveHouseSpaceBeanList.map(item => ({
            ...item,
            houseSpaceArea: Number(item.houseSpaceArea1) * 1000,
            houseSpaceArea1: undefined,
          }))
        }

        var url = this.$store.state.houseUrl + 'save/houseSpace'
        this.$http.post(url, data).then(res => {
          if (res.body.code === 200) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.$emit('addSuccess')   // 通过发送事件，关闭弹出框
            this.$options.methods.gbAddBean(this)   // 清空输入项
          } else {
            this.$message({
              message: res.body.message,
              type: 'error'
            })
          }
          this.clickOver = true
        })
      }
      // 新增结束
        } else {
          console.log('error submit!!')
        }
      })

    },
    // 集中式新增
    tabBclick () {
      if (this.clickOver) {
        this.clickOver = false
        var url = this.$store.state.houseUrl + 'save/house/centralize'
        this.centralizeData.houseSpaceManagerType = 'HOUSE'
        this.centralizeData.propertyType = 'C'
        this.centralizeData.originalRentType = 'ENTIRE_RENT'
        let list = this.centralizeData.reqCommonCentralizeHouseSpaceBeanList
        let areaCount = 0
        let roomCount = 0
        this.centralizeData.getPrice = this.centralizeData.getPrice1 * 1000
        this.centralizeData.floorHeight = this.centralizeData.floor
        for (let i in this.centralizeData.reqCommonCentralizeHouseSpaceBeanList) {
          if (list[i].houseSpaceManagerArea1 * 1000 > 0) {
            list[i].houseSpaceManagerArea = list[i].houseSpaceManagerArea1 * 1000
          } else {
            areaCount++
          }
          if (this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[i].roomNoList.length === 0) {
            roomCount++
          }
        }
        if (areaCount > 0) {
          this.$message({
            message: '房源面积有误，请确认后重新提交',
            type: 'error'
          })
          this.clickOver = true
        } else if (roomCount > 0) {
          this.$message({
            message: '请选择正确的房间',
            type: 'error'
          })
          this.clickOver = true
        } else if (this.centralizeData.houseOwnershipCertificateNumber === null || this.centralizeData.houseOwnershipCertificateNumber === '') {
          this.$message({
            message: '请填写房屋产权证号',
            type: 'error'
          })
          this.clickOver = true
        } else if (
          this.centralizeData.companyId === null || this.centralizeData.companyId === ''
        ) {
          this.$message({
            message: '请选择所属公司',
            type: 'error'
          })
          this.clickOver = true
        } else {
          this.centralizeData.inputPersonnelId = this.$store.state.currentUser.uid
          this.$http.post(url, this.centralizeData).then((data1) => {
            if (data1.body.code === 200) {
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$emit('addSuccess')
              this.$options.methods.gbAddBean1(this)
              this.tableNumber = '1'
              this.activeName2 = '1'
            } else if (data1.body.code === 10002) {
              this.$message({
                message: '该房源已存在，请不要重复添加',
                type: 'error'
              })
            } else {
              this.$message({
                message: data1.body.message,
                type: 'error'
              })
            }
            this.clickOver = true
          })
        }
      }
    },
    querySearch (queryString, cb) { // 小区信息
      this.restaurants1 = []
      if (queryString) {
        let req = {}
        req.baseDataType = 'BLOCK_INFO'
        req.blockName = queryString
        let bankSearch = this.$store.state.searchUrl + 'baseDataInfo'
        this.$http.post(bankSearch, req).then(res => {
          if (res.body.code === 200) {
            // _this.form.bankOfAccounts = res.body.data[0].branchBankName
            let len = 0
            // console.log(res.body.data)
            if (res.body.data.length > 10) {
              len = 10
            } else {
              len = res.body.data.length
            }
            for (let i = 0; i < len; i++) {
              let list = {}
              list.value = res.body.data[i].blockName
              list.district = res.body.data[i].district
              list.province = res.body.data[i].province
              list.city = res.body.data[i].city
              list.pid = res.body.data[i].pid
              this.restaurants1.push(list)
            }
          }
        })
      }
      var restaurants = this.restaurants1
      // 调用 callback 返回建议列表的数据
      cb(restaurants)
    },
    handleSelect1 (item) {
      this.centralizeData.blockName = item.value
      this.centralizeData.province = item.province
      this.centralizeData.city = item.city
      this.centralizeData.district = item.district
      this.centralizeData.blockId = item.pid

      this.centralizeData.projectId = item.pid
    },
    createFilter (queryString) { // 小区信息
      return (restaurant) => {
        return (restaurant.value.indexOf(queryString.toLowerCase()) === 0)
      }
    },
    houseQuerySearch (queryString) { // 搜索预录入房源列表
      // var url = this.$store.state.houseUrl + 'list/houseSpaceManager'
      let req = {}
      req.keywordAddressManager = queryString
      req.landlordPhone = this.addBean.landlordPhone
      req.landlordName = this.addBean.landlordName
      req.originalRentType = this.addBean.originalRentType || null
      this.$options.methods.houseListSearch(this, this.mix1.houseApi, req)
    },
    houseQuerySearch1 (queryString) { // 搜索预录入房源列表
      let req = {}
      this.houseRestaurants = []
      this.addBean.houseSpaceManagerId = ''
      this.addBean.houseSpaceManagerArea = ''
      req.keywordAddressManager = ''
      req.landlordPhone = this.addBean.landlordPhone
      req.originalRentType = this.addBean.originalRentType || null
      this.$options.methods.houseListSearch(this, this.mix1.houseApi, req)
      if (this.addBean.originalRentType === 'ENTIRE_RENT') {
        this.$options.methods.changeRoomNumber1(1, this)
      } else {
        this.addBean.roomNumber = 1
      }
    },
    handleSelect (item) { // 选择小区信息
      for (let i = 0; i < this.houseRestaurants.length; i++) {
        if (this.addBean.houseSpaceManagerId === this.houseRestaurants[i].houseSpaceManagerId) {
          this.addBean.bedroom_number = parseInt(this.houseRestaurants[i].bedroomNumber + 1)
          this.addBean.bedroom_number = 10
          this.addBean.roomNumber = 1
          let reqBaseSaveHouseSpaceBeanList = {}
          reqBaseSaveHouseSpaceBeanList.rentalPrice1 = this.houseRestaurants[i].getPrice / 1000
          reqBaseSaveHouseSpaceBeanList.houseSpaceArea1 = this.houseRestaurants[i].houseSpaceManagerArea / 1000
          reqBaseSaveHouseSpaceBeanList.direction = this.houseRestaurants[i].houseSpaceManagerDirection
          reqBaseSaveHouseSpaceBeanList.roomName = 'A'
          reqBaseSaveHouseSpaceBeanList.houseSpaceFeatureList = []
          reqBaseSaveHouseSpaceBeanList.roomName = 'A'
          this.addBean.reqBaseSaveHouseSpaceBeanList = []
          this.addBean.houseSpaceManagerArea = reqBaseSaveHouseSpaceBeanList.houseSpaceArea1
          this.addBean.reqBaseSaveHouseSpaceBeanList.push(reqBaseSaveHouseSpaceBeanList)
        }
      }
    },
    userQuerySearch (queryString, cb) { // 房东信息
      var option = []
      if (queryString) {
        // 查询租客
        this.$http.post(this.mix.userUrl, {
          username: queryString, pageNo: 1, pageSize: 50
        }).then(({data}) => {
          if (data.code === 200) {
            var data1 = data.data.list
            var op = {}
            for (var i = 0; i < data1.length; i++) {
              if (data1[i].username === '' || data1[i].username === null || typeof (data1[i].username) === 'undefined') {
              } else {
                op = {}
                op.id = data1[i].id
                op.phone = data1[i].phone
                op.sex = data1[i].sex
                op.value = data1[i].username
                option.push(op)
              }
            }
            this.landlordList = option
          } else {
            this.landlordList = []
          }
        })
        cb(option)

        // 查询房源
        let req = {}
        req.keywordAddressManager = ''
        req.landlordPhone = this.addBean.landlordPhone
        req.landlordName = this.addBean.landlordName
        req.originalRentType = this.addBean.originalRentType || null
        this.$options.methods.houseListSearch(this, this.mix1.houseApi, req)
        if (this.addBean.originalRentType === 'ENTIRE_RENT') {
          this.$options.methods.changeRoomNumber1(1, this)
        }
      }
      // }
    },
    userQuerySearch1 (queryString, cb) { // 房东信息
      // if (queryString !== '' && queryString !== null) {
      var option = []
      if (queryString) {
        this.$http.post(this.mix.userUrl, {
          username: queryString, pageNo: 1, pageSize: 50
        }).then(({data}) => {
          if (data.code === 200) {
            var data1 = data.data.list
            var op = {}
            // var option = []
            for (var i = 0; i < data1.length; i++) {
              if (data1[i].username === '' || data1[i].username === null || typeof (data1[i].username) === 'undefined') {
              } else {
                op = {}
                op.id = data1[i].id
                op.phone = data1[i].phone
                op.sex = data1[i].sex
                op.value = data1[i].username
                option.push(op)
              }
            }
            this.landlordList = option
          } else {
            this.landlordList = []
          }
        })

        // 查询房源
        let req = {}
        req.keywordAddressManager = ''
        req.landlordPhone = this.addBean.landlordPhone
        req.landlordName = this.addBean.landlordName
        req.originalRentType = this.addBean.originalRentType || null
        this.$options.methods.houseListSearch(this, this.mix1.houseApi, req)
        if (this.addBean.originalRentType === 'ENTIRE_RENT') {
          this.$options.methods.changeRoomNumber1(1, this)
        }
      }
      cb(option)
      // }
    },
    userFilter (queryString) { // 房东信息
      return (restaurant) => {
        return (restaurant.value.indexOf(queryString.toLowerCase()) === 0)
      }
    },
    userSelect (item) { // 选择房东信息
      this.addBean.landlordPhone = item.phone
      this.addBean.landlordId = item.id
      // 查询房源
      let req = {}
      req.keywordAddressManager = ''
      req.landlordId = this.addBean.landlordId
      req.originalRentType = this.addBean.originalRentType || null
      this.$options.methods.houseListSearch(this, this.mix1.houseApi, req)
      if (this.addBean.originalRentType === 'ENTIRE_RENT') {
        this.$options.methods.changeRoomNumber1(1, this)
      }
    },
    userSelect1 (item) {
      this.centralizeData.landlordPhone = item.phone
      this.centralizeData.landlordId = item.id
      this.centralizeData.sex = item.sex
      var url = this.mix.userId + item.id
      this.$http.get(url).then(({data}) => {
        if (data.code === 200) {
          this.centralizeData.landlordCertType = data.data.certType
          this.centralizeData.landlordCertNumber = data.data.certNumber
        }
      })
    },
    unitSelect (_this, userUrl) { // 搜索片区
      _this.unitList = []
      _this.$http.get(userUrl).then(({data}) => {
        // var data1 = data.data.children[0].children
        var data1 = data.data.children
        _this.unitFormat(_this, data.data.children)
        _this.unit = data1
        _this.addBean.zone = _this.unit[0].text
        _this.addBean.zoneId = _this.unit[0].id
        _this.centralizeData.zone = _this.unit[0].text
        _this.centralizeData.zoneId = _this.unit[0].id
      })
    },
    unitFormat (_this, arr) { // 格式化片区列表
      // console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        // arr[i].value = arr[i].text
        arr[i].value = arr[i].id
        arr[i].label = arr[i].text
        arr[i].cities = arr[i].children
        _this.unitList.push(arr[i])
        if (arr[i].children !== null && arr[i].children !== [] && arr[i].children !== '') {
          _this.unitFormat(_this, arr[i].children)
        }
      }
      return arr
    },
    // zoneChange (data) { // 选择片区
    //   // console.log(data)
    //   this.addBean.zoneId = data
    // },
    unitChange (value) {
      for (let i in this.unit) {
        if (this.unit[i].id === value) {
          this.addBean.zone = this.unit[i].text
        }
      }
    },
    changeZone (value) {
      for (let i in this.unit) {
        if (this.unit[i].id === value) {
          this.centralizeData.zone = this.unit[i].text
        }
      }
    },
    addHouseType () {
      var obj = {}
      obj.bedroomNumber = '1'
      obj.direction = ''
      obj.houseSpaceList = []
      obj.houseSpaceManagerArea = ''
      obj.livingRoomNumber = '1'
      obj.kitchenNumber = '0'
      obj.name = ''
      obj.toiletNumber = '1'
      obj.getPrice1 = ''
      obj.houseSpaceFeatureList = []
      obj.roomNoList = []
      this.centralizeData.reqCommonCentralizeHouseSpaceBeanList.push(obj)
    },
    gbAddBean (_this) { // 格式化addBean
      _this.addBean.houseSpaceManagerArea1 = ''
      _this.addBean.getPrice = ''
      _this.addBean.getPrice1 = ''
      _this.addBean.houseSpaceDescribe = ''
      _this.addBean.houseSpaceFeatureList = []
      _this.addBean.zone = '城东片区'
      _this.addBean.zoneId = ''
      _this.addBean.userId = ''
      _this.addBean.landlordName = ''
      _this.addBean.landlordPhone = ''
      _this.addBean.propertyType = 'D'
      _this.addBean.originalRentType = ''
      _this.addBean.houseSpaceManagerId = ''
      _this.addBean.roomNumber = '0'
      _this.addBean.bedroom_number = 6
      _this.addBean.reqBaseSaveHouseSpaceBeanList = []
      let list = {}
      list.bedroomType = 'MASTER'
      list.direction = ''
      list.houseSpaceArea = ''
      list.houseSpaceArea1 = ''
      list.rentalPrice = ''
      list.rentalPrice1 = ''
      list.roomName = ''
      list.reqBaseSaveHouseSpaceBeanList = []
      list.houseSpaceFeatureList = []
      _this.addBean.reqBaseSaveHouseSpaceBeanList.push(list)
    },
    gbAddBean1 (_this) {
      _this.centralizeData.userId = '' // 房东ID
      _this.centralizeData.landlordCertType = 'ID' // 身份证件类型
      _this.centralizeData.landlordCertNumber = '' // 证件号码
      _this.centralizeData.landlordName = ''
      _this.centralizeData.landlordPhone = ''
      _this.centralizeData.sex = 'M'
      _this.centralizeData.zone = _this.unit[0].text // 片区
      _this.centralizeData.zoneId = _this.unit[0].id // 片区
      _this.centralizeData.blockName = '' // 小区
      _this.centralizeData.housePrice = '' // 价格
      _this.centralizeData.housePrice1 = '' // 价格
      _this.centralizeData.floor = 10 // 楼层
      _this.centralizeData.currentFloor1 = [] // 选择楼层
      _this.centralizeData.roomNumber = '' // 每层房间数量
      _this.centralizeData.memo = '' // 备注
      _this.centralizeData.unitNo = ''
      _this.centralizeData.buildingNo = ''
      _this.centralizeData.city = ''
      _this.centralizeData.province = ''
      _this.centralizeData.district = ''
      _this.centralizeData.blockId = ''
      _this.centralizeData.reqCommonCentralizeHouseSpaceBeanList = [] // 户型
      let list = {}
      list.name = ''
      list.bedroomNumber = '1'
      list.livingRoomNumber = '1'
      list.kitchenNumber = '0'
      list.toiletNumber = '1'
      list.direction = ''
      list.houseSpaceManagerArea = ''
      list.houseSpaceManagerArea1 = ''
      list.roomNoList = []
      list.houseSpaceFeatureList = [] // 优势
      _this.centralizeData.reqCommonCentralizeHouseSpaceBeanList.push(list)
    },
    inputBlur (item, data) {
      let list = this.centralizeData.reqCommonCentralizeHouseSpaceBeanList
      for (var i = 0; i < (list.length - 1); i++) {
        if (i !== data) {
          if (item.bedroomNumber === list[i].bedroomNumber && item.livingRoomNumber === list[i].livingRoomNumber && item.toiletNumber === list[i].toiletNumber && item.direction === list[i].direction && item.houseSpaceManagerArea1 === list[i].houseSpaceManagerArea1) {
            this.$message({
              message: '房型重复',
              type: 'error'
            })
            this.houseRepeat = 1
          } else {
            this.houseRepeat = 0
          }
        }
      }
    },
    reduceHouseType (lists, index) { // 删除当前物品
      var arr = this.houseSpaceListing
      var arr2 = lists[index].roomNoList
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr[i] === arr2[j]) {
            arr.splice(i, 1)
            i--
          }
        }
      }
      lists.splice(index, 1)
    },
    addHouse (data) {
      var _this = this
      var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
      let list1 = this.centralizeData.reqCommonCentralizeHouseSpaceBeanList
      for (var i = 0; i <= (list1.length - 1); i++) {
        for (var j = (list1.length - 1 - i); j >= 0; j--) {
          if (list1[j].bedroomNumber === list1[i].bedroomNumber && list1[j].livingRoomNumber === list1[i].livingRoomNumber && list1[j].toiletNumber === list1[i].toiletNumber && list1[j].direction === list1[i].direction && list1[j].houseSpaceManagerArea1 === list1[i].houseSpaceManagerArea1 && j !== i) {
            _this.$message({
              message: '房型重复',
              type: 'error'
            })
            _this.houseRepeat = 1
          } else if (!list1[j].houseSpaceManagerArea1 || !reg.test(list1[j].houseSpaceManagerArea1)) {
            _this.houseRepeat = 1
            _this.$message({
              message: '请检查房型面积是否填写或者填写是否有误',
              type: 'error'
            })
          } else {
            _this.houseRepeat = 0
            var list = []
            if (_this.centralizeData.currentFloor1 && _this.centralizeData.roomNumber) {
              _this.houseSpaceList = []
              // for (let i = 1; i <= this.centralizeData.floor; i++) {
              _this.centralizeData.currentFloor1 = _this.$options.methods.orderHouseList(_this.centralizeData.currentFloor1)
              for (let i in _this.centralizeData.currentFloor1) {
                let list1 = []
                for (let j = 1; j <= parseInt(_this.centralizeData.roomNumber); j++) {
                  let list2 = []
                  let str = ''
                  if (j < 10) {
                    str = _this.centralizeData.currentFloor1[i] + '0' + j
                  } else {
                    str = _this.centralizeData.currentFloor1[i] + '' + j
                  }
                  list2.push(str)
                  list1 = list1.concat(list2)
                }
                list.push(list1)
              }
              _this.houseSpaceList = list
              // console.log(_this.houseSpaceList)
              var arr = _this.houseSpaceList
              for (let i = 0; i < arr.length; i++) {
                for (let j = 0; j < arr[i].length; j++) {
                  for (let k = 0; k < _this.houseSpaceListing.length; k++) {
                    if (parseInt(arr[i][j]) === parseInt(_this.houseSpaceListing[k])) {
                      arr[i].splice(j, 1)
                      j--
                    }
                  }
                }
              }
              _this.chooseHouseTypeShow = true
              _this.houseSpaceIndex = data
            } else {
              _this.$message({
                message: '请输入正确的楼层及每层房间数',
                type: 'error'
              })
            }
          }
        }
      }
    },
    chooseHouseListTrue () {
      var leng = this.houseSpaceIndex
      this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[leng].roomNoList = this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[leng].roomNoList.concat(this.houseSpaceListChoose)
      let arr = []
      arr = this.houseSpaceListing
      this.houseSpaceListing = arr.concat(this.houseSpaceListChoose)
      // console.log(this.centralizeData)
      this.houseSpaceListChoose = []
      this.chooseHouseTypeShow = false
    },
    addFloor () {
      // this.centralizeData.currentFloor1 = []
      let len = this.centralizeData.currentFloor1
      for (var i = 0; i < len.length; i++) {
        if (this.centralizeData.floor < parseInt(len[i])) {
          len.splice(i, 1)
          i--
        }
      }
    },
    chooseFloor (e) { // 选择楼层
      let floor = this.centralizeData.currentFloor1
      let roomList = this.centralizeData.reqCommonCentralizeHouseSpaceBeanList
      if (e.srcElement.className.indexOf('cur') < 0) {
        e.srcElement.className = 'floor cur'
        floor.splice(floor.length, 0, e.srcElement.innerText)
      } else {
        e.srcElement.className = 'floor'
        for (var i in floor) {
          if (parseInt(floor[i]) === parseInt(e.srcElement.innerText)) {
            for (let j = 0; j < roomList.length; j++) {
              for (let k = roomList[j].roomNoList.length - 1; k >= 0; k--) {
                if (parseInt(roomList[j].roomNoList[k].toString().substr(0, roomList[j].roomNoList[k].toString().length - 2)) === parseInt(floor[i])) {
                  // console.log(roomList[j].roomNoList[k])
                  roomList[j].roomNoList.splice(k, 1)
                }
              }
            }
            for (let k = this.houseSpaceListing.length - 1; k >= 0; k--) {

              if (parseInt(this.houseSpaceListing[k].toString().substr(0, this.houseSpaceListing[k].toString().length - 2)) === parseInt(floor[i])) {
                this.houseSpaceListing.splice(k, 1)
              }
            }
            floor.splice(i, 1)
          }
        }
      }
    },
    // 查询房源信息
    houseListSearch (_this, url, req) {
      req.registration = 'PRE'
      _this.$http.post(url, req).then(res => {
        if (res.body.code === 200) {
          if (res.body.data.totalCount > 10) {
            _this.houseRestaurants = res.body.data.list.splice(0, 10)   // 只要前十条数据
          } else {
            _this.houseRestaurants = res.body.data.list
          }
        } else {
          _this.houseRestaurants = []
        }
      })
    },
    changeRoomNumber (value) {
      let val = parseInt(value)
      let arr = []
      for (var i = 0; i < val; i++) {
        let list = {}
        list.bedroomType = 'MASTER'
        list.direction = ''
        list.houseSpaceArea = ''
        list.houseSpaceArea1 = ''
        list.rentalPrice = ''
        list.rentalPrice1 = ''
        list.houseSpaceFeatureList = []
        const roomNameStr = 'ABCDEFGHIJKLMNOP'
        list.roomName = roomNameStr.charAt(i)
        arr.push(list)
      }
      this.addBean.reqBaseSaveHouseSpaceBeanList = arr
    },
    changeRoomNumber1 (value, _this) {
      // 只对合租起作用
      if (_this.addBean.originalRentType !== 'JOINT_RENT') return

      let val = parseInt(value)
      let arr = []
      for (var i = 0; i < val; i++) {
        let list = {}
        list.bedroomType = 'MASTER'
        list.direction = ''
        list.houseSpaceArea = ''
        list.houseSpaceArea1 = ''
        list.rentalPrice = ''
        list.rentalPrice1 = ''
        const roomNameStr = 'ABCDEFG'
        list.roomName = roomNameStr.charAt(i)
        arr.push(list)
      }
      _this.addBean.reqBaseSaveHouseSpaceBeanList = arr
    },
    getHouseList () { // 打开房间列表弹窗
      for (let i = 0; i < this.centralizeData.reqCommonCentralizeHouseSpaceBeanList.length; i++) {
        this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[i].roomNoList = this.$options.methods.orderHouseList(this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[i].roomNoList)
        // this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[i] = this.$options.methods.tagHouseList(this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[i])
      }
      this.chooseHouseListShow = true
      // console.log(this.centralizeData)
    },
    orderHouseList (list) {
      let lenhtn = list.length
      let lenhtm = lenhtn
      for (let i = 0; i < lenhtn; i++) {
        list[i] = parseInt(list[i])
      }
      for (let i = 0; i < lenhtn; i++) {
        lenhtm--
        for (let j = 0; j < lenhtm; j++) {
          if (list[j] > list[j + 1]) {
            let a = list[j]
            list[j] = list[j + 1]
            list[j + 1] = a
          }
        }
      }
      return list
    },
    removeRoomList (index, list, tag) {
      // console.log(this.houseSpaceListing)
      this.$options.methods.orderHouseList(this.houseSpaceListing)
      this.removeHouseList.push(list[list.indexOf(tag)].name)
      this.centralizeData.reqCommonCentralizeHouseSpaceBeanList[index].roomNoList.splice(list.indexOf(tag), 1)
      this.houseSpaceListing.splice(this.houseSpaceListing.indexOf(tag), 1)
    },
    // 查询关联公司
    companyListFind() {
      var companyListApi = this.$store.state.houseUrl + 'company/list/all'
      this.$http.get(companyListApi).then(val => {
        if (val.body.code === 200) {
          this.companyListAll = val.body.data
        } else {
          this.$message({
            message: val.body.message,
            type: 'error'
          })
        }
      })
    },
    changeP (item) { // 改变省份
      let _this = this
      // console.log(111)
      this.$http.post(this.bankSearch, {'baseDataType': 'CITY_INFO', 'provinceId': item}).then(function (valueD) {
        _this.address.cLists = valueD.data.data
        _this.centralizeData.city = valueD.data.data[0].cityId
        this.centralizeData.district = ''
      })
    },
    changeC (item) { // 改变城市
      let _this = this
      this.$http.post(this.bankSearch, {'baseDataType': 'AREA_INFO', 'cityId': item}).then(function (valueD) {
        _this.address.dLists = valueD.data.data
        _this.centralizeData.district = valueD.data.data[0].areaId
      })
    },
    changeD (item) { // 改变区县
      // console.log(333)
      // let searchUrl = this.$store.state.searchUrl + 'save'
      // let req = {}
      // console.log(this.form)
      // req.blockName = this.form.blockName
      // req.city = this.form.city
      // req.province = this.form.province
      // req.district = this.form.district
      // this.$http.post(searchUrl, req).then(function (valueD) {
      //   console.log(valueD)
      // })
    }
  },
}
$('.el-dialog--small').width(650)



// WEBPACK FOOTER //
// ./src/components/forms/HouseForm/script.js